import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Steps.css";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from 'dayjs';
import axios from "axios";
import { API_URL } from "../../../redux/actions/api";
import Card from '@mui/material/Card';
import moment from "moment";
import { TextField, Button, CircularProgress } from "@mui/material";
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import { useForwardChevron } from '../../../i18n/DirectionalIcons';
import { useT } from "../../../i18n";

function Step3(props) {
    console.log("step 3 start");
  const location = useLocation();
  const t = useT();
  const FwdChevron = useForwardChevron();
  const {user} = useSelector((state) => state.auth)
  const department = user?.departments.find(d => d.id == props.formData.department_id)

  const [loading, setLoading] = useState(true)
  const [doctors, setDoctors] = useState([])

  const [inputVal, setInputVal] = useState('')
  const [selected, setSelected] = useState(null) // always start fresh — no pre-selection on re-entry

  useEffect(() => {
    setLoading(true)
    axios.get(API_URL +'doctors?department_id=' + props.formData.department_id)
      .then((res) => {
        const rows = res.data.data.rows;
        setDoctors(rows);
        // Pre-select the service when re-entering this step: A8 (going back → the service chosen
        // before stays selected via formData.schedule_id) or C7 rebook (_rebookScheduleId), as long
        // as it still has open slots.
        const preselectId = props.formData.schedule_id || props.formData._rebookScheduleId;
        if (preselectId) {
          const match = rows.find(d => d.id == preselectId && d.slots && d.slots.length);
          if (match) setSelected(match);
        }
      })
      .catch(() => { setDoctors([]) })
      .finally(() => { setLoading(false) })
  },[])

  // pick the service (highlight it as "נבחר") — do NOT advance yet
  const Click = (doctor) => {
    if(!doctor.slots || !doctor.slots.length) {
      return;
    }
    setSelected(doctor);
  }

  // confirm the chosen service and move on
  const Confirm = () => {
    if (!selected) return;
    props.setFormData({...props.formData,
      schedule_id : selected.id,
      doctor: selected
    })
    props.next()
  }

  const SearchFunc = (e) => {
    setInputVal(e.target.value)
    axios.get(API_URL +'doctors?department_id=' + props.formData.department_id + '&q=' + e.target.value).then((res) =>{
      setDoctors(res.data.data.rows)
    })
  }

  const Slot = (props) => {
       const slots = props.slots.sort((a, b) => {
  const dateA = dayjs(a.wdate);
  const dateB = dayjs(b.wdate);
  const timeA = dayjs(a.start_time, 'HH:mm:ss');
  const timeB = dayjs(b.start_time, 'HH:mm:ss');

  // Compare dates first
  if (!dateA.isSame(dateB)) {
    return dateA - dateB;
  }

  // Dates are the same, compare times
  return timeA - timeB;
});  
   // const firstSlot = props.slots.sort((a, b) => moment(a.wdate).isBefore(moment(b.wdate)))[0];
     const firstSlot = slots[0];

    return (
      <div>
        {t("step3.nearestSlot")}
        <br/>
        {moment(firstSlot.wdate).format('DD/MM/YYYY')} &nbsp;|&nbsp;
        {t("common.atTime", { time: moment('2023-12-12 ' + firstSlot.start_time).format('HH:mm') })}
      </div>
    )

  }

  
  return (
    <div className="step step3">
      <h5>{t("step3.title")}</h5>

{/*<TextField value={inputVal} onChange={SearchFunc} className="search_med" autoFocus fullWidth placeholder="חיפוש שם / כתובת" />*/}

  <div className="doctors-list doctors-list-scroll">
      {loading ? (
        <div className="ans-loading-slots">
          <CircularProgress size={46} thickness={4} />
          <div className="ans-loading-slots-text">{t("step3.loadingSlots")}</div>
        </div>
      ) : doctors.length === 0 ? (
        <div className="ans-loading-slots">
          <div className="ans-loading-slots-text">{t("step3.noServices")}</div>
        </div>
      ) : doctors.map(doctor => (
         <Card onClick={() => Click(doctor)} key={doctor.id}
           className={selected?.id === doctor.id ? 'service-selected' : ''}>
          {selected?.id === doctor.id && <span className="selected-badge">✓</span>}
          {doctor.slots && doctor.slots.length > 0 && (
            <FwdChevron className="card-chevron" />
          )}
          <div className="doc_title bold">{doctor.title}</div>
          {doctor.address && (
            <div className="doc_address">
                <LocationOnRoundedIcon />
                {doctor.address}
            </div>
          )}
          <br/>
          {(!doctor.slots || !doctor.slots.length)
            ? <div>{t("step3.noSlot")}</div>
            : <Slot  slots={doctor.slots}/>}
          </Card>
      ))}
       </div>

      <Button
        variant="contained"
        disabled={!selected}
        className="next-btn"
        onClick={Confirm}
        sx={{ borderRadius: 0, fontSize: 18 }}
        endIcon={<FwdChevron />}
      >
        {t("common.next")}
      </Button>
    </div>
  );
}

export default Step3;
